import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type Employee } from '@avanta/shared/types/employees';
import { type AxiosResponse } from 'axios';
import { getUserId } from 'utils/storage';

const EMPLOYEES_URL = `${BASE_URL}employees`;

type EmployeeServiceTypes = {
  updateEmployee: (employee: Employee) => Promise<AxiosResponse<Employee>>;
};

export const EmployeeService: EmployeeServiceTypes = {
  updateEmployee: async employee =>
    service.put(`${EMPLOYEES_URL}/${getUserId()}`, { ...employee, type: 'EmployeeToRegisterDTO' }),
};
